import React from 'react';
import PropTypes from 'prop-types';

import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import CloudOffIcon from '@material-ui/icons/CloudOff';

function ServerError(props) {
  const { title, children, icon } = props;
  return (
    <Alert className="margin-top-20" icon={icon} severity="info" style={{ textAlign: 'left' }}>
      <AlertTitle>{title}</AlertTitle>
      {children}
    </Alert>
  );
}

ServerError.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  icon: PropTypes.node,
};

ServerError.defaultProps = {
  title: 'Something went wrong',
  children: <p>Please try again later</p>,
  icon: <CloudOffIcon color="secondary" fontSize="inherit" />,
};

export default ServerError;
